<div class="flex flex-col h-full gap-6">
	<p class="mt-4">Confirm the following details:</p>
	<div class="flex gap-6 flex-1">
		<div class="flex gap-2 flex-col">
			<div>
				<app-icon [icon]="ICON.ADDRESS_CARD" class="mr-2"></app-icon>
				<span>Primary ID</span>
			</div>
			<div *ngIf="stepCount === 4">
				<app-icon [icon]="ICON.ADDRESS_CARD" class="mr-2"></app-icon>
				<span>Secondary ID</span>
			</div>
		</div>
		<div class="flex gap-2 flex-col">
			<div [class]="hasFirstId ? 'text-green' : 'text-grey-darker'">
				<app-icon
					[icon]="hasFirstId ? ICON.CHECK : ICON.XMARK"
					class="mr-2"
				></app-icon>
				<span>{{ hasFirstId ? 'synced' : 'not synced' }}</span>
			</div>
			<div
				*ngIf="stepCount === 4"
				[class]="hasSecondId ? 'text-green' : 'text-grey-darker'"
			>
				<app-icon
					[icon]="hasSecondId ? ICON.CHECK : ICON.XMARK"
					class="mr-2"
				></app-icon>
				<span>{{ hasSecondId ? 'synced' : 'not synced' }}</span>
			</div>
		</div>
	</div>

	<div class="flex justify-between mt-4">
		<app-button size="small" btn="clear" (onClick)="back()">Back</app-button>

		<div class="flex gap-x-4">
			<app-button
				size="small"
				btn="primary"
				[loading]="isSending"
				(onClick)="confirm()"
				>Confirm</app-button
			>
		</div>
	</div>
</div>
